module.exports = __webpack_public_path__ + "img/wow.fd662dc2.png";